import React from 'react'
import styled from 'styled-components'
import Link from "./linkMenu";
import Image from "./image";
import backArrow from "../assets/backDark.png"

const MenuDiv = styled.div`
  background-color: #fff;
  box-shadow: 0px 0px 5px 0px rgb(222,222,222);
  width: 100vw;
  height: 50px;
  position: fixed;
  top: 50px;
  left: 0;
  box-sizing: border-box;
`

const List = styled.ul`
  list-style-type: none;
  height: 50px;
  max-width: 1080px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const MarginImg = styled.div`
    margin-left: 15px;
`

const Menu = () => {
    const token = localStorage.getItem('token')
    return (
        token !== 'guest' ?
            <MenuDiv>
                <List>
                    {window.location.pathname.split("/")[1] !== "dashboard" ?
                        <li>
                            <MarginImg>
                                <Image src={backArrow} width="25" cursor="pointer"
                                       onClick={() => window.history.back()}/>
                            </MarginImg>
                        </li>
                        : null}
                    <li><Link content="Créer une licence" link="/create-licence"/></li>
                    <li><Link content="Utilisateurs" link="/create-user"/></li>
                    <li><Link content="Les clubs" link="/clubs"/></li>
                </List>
            </MenuDiv>
            : null
    )
}

export default Menu
